import { render, staticRenderFns } from "./ControlTab.vue?vue&type=template&id=18748584"
import script from "./ControlTab.vue?vue&type=script&lang=ts"
export * from "./ControlTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports